import React, { useState, useEffect } from 'react';
import { Tabla } from './Tabla';
import ObtenerPaises from '../functions/ObtenerPaises';
import PaisTabla from '../types/PaisTabla';


interface ListarPaisesProps {
    defaultItemsPerPage?: number;
    handleEditPais: (pais: PaisTabla) => void;
    handleDeletePais: (pais: PaisTabla) => void;
    handleAddPais: () => void;
}

export const ListarPaises: React.FC<ListarPaisesProps> = ({ defaultItemsPerPage = 15, handleEditPais, handleDeletePais, handleAddPais, }) => {
  
  const [paises, setPaises] = useState<PaisTabla[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [itemsPerPage, setItemsPerPage] = useState(defaultItemsPerPage);

  const handleMostrarCredencial = (pais: PaisTabla) => {
    console.log('Mostrar credencial', pais);
  };

  const handleUbication = (pais: PaisTabla) => {
    console.log('Mostrar ubicacion', pais);
  };
  
  useEffect(() => {
    const fetchPaises = async () => {
      try {
        const data = await ObtenerPaises();
        setPaises(data.paises);
        setLoading(false);
      } catch (err) {
        setError('Error al obtener los paises');
        setLoading(false);
      }
    };

    fetchPaises();
  }, []);

  const columns = [
    { key: 'id', label: 'ID', align: 'center' as const },
    { key: 'nombre', label: 'PAIS', align: 'left' as const },
    { key: 'codigo_iso', label: 'CODIGO ISO', align: 'center' as const },
    { key: 'codigo_telefonico', label: 'CODIGO TEL', align: 'left' as const },
    { key: 'habilitado', label: 'HABILITADO', align: 'center' as const },
  ];

  const handleEdit = (pais: PaisTabla) => {
    handleEditPais(pais);
  };

  const handleDelete = (pais: PaisTabla) => {
    handleDeletePais(pais);
  };


  if (loading) return <div>Cargando...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 mt-5">
      <div className="flex flex-row justify-between items-center mb-3">
        <div className="flex flex-col justify-center items-center">
          <h1 className="font-metropolis text-xl font-bold">Paises cargados</h1>
        </div>
        <div className="flex flex-col justify-center items-center">
          <button className="vp-btn-azul-sm" onClick={handleAddPais}>Nuevo Pais</button>
        </div>
      </div>
      <Tabla columns={columns} data={paises} onEdit={handleEdit} onDelete={handleDelete} itemsPerPage={itemsPerPage} onCredencial={handleMostrarCredencial} onUbication={handleUbication} acciones={['editar','eliminar']}/>
    </div>
  );
};